import { RESOURCE_ICONS } from "./resource_icons";

// Chip styling from config/resource_chips.yml, which Ruby also reads to style dashboard table pills.
const CONFIG_SELECTOR = "[data-resource-chip-config]";
const NEUTRAL_STYLE = "bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100";

// Not cached: the tag is per-document, and Turbo frame renders can add or replace it.
function config() {
  try {
    return JSON.parse(document.querySelector(CONFIG_SELECTOR).textContent);
  } catch {
    return { default: NEUTRAL_STYLE, types: {} };
  }
}

export function resourceIcon(type) {
  return RESOURCE_ICONS[config().types?.[type]?.icon];
}

export function resourceStyle(type) {
  const { default: fallback = NEUTRAL_STYLE, types = {} } = config();
  return types[type]?.style || fallback;
}

export function resourceChipClass(type) {
  return `${config().base || ""} ${resourceStyle(type)}`.trim();
}

export function resourceOpensNewTab(type) {
  return Boolean(config().types?.[type]?.newTab);
}
